import PropTypes from "prop-types";

export const TrendingUpIcon = ({ width = 12, height = 12, stroke = "#2DCE89" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5 3.5L6.75 8.25L4.25 5.75L0.5 9.5"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.5 3.5H11.5V6.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

TrendingUpIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  stroke: PropTypes.string,
};
